module.exports = __webpack_public_path__ + "img/TOEI_EN.549f7567.jpg";